<script>
import cases from '@/api/cases'
import UserLinkComponent from '@/components/Profile/UserLinkComponent.vue'

function validationMessage(error) {
  const data = error && error.response && error.response.data
  const errors = data && data.errors
  if (errors && typeof errors === 'object') {
    const messages = Object.keys(errors).reduce((list, key) => {
      const value = errors[key]
      if (Array.isArray(value)) return list.concat(value)
      if (value) list.push(String(value))
      return list
    }, [])
    if (messages.length) return messages.join(' ')
  }
  if (data && data.message) return data.message
  return 'Не удалось создать проект'
}

export default {
  name: 'CaseItemComponent',
  components: { UserLinkComponent },
  data() {
    return {
      loading: false,
      isCaseProjectLoading: false,
      createError: '',
      errors: [],
      projectCase: {
        id: 0,
        title: '',
        projectTypeId: null,
        companyName: '',
        companyDescription: '',
        companyRepresentativeName: '',
        companyRepresentativePosition: '',
        currentState: '',
        product: '',
        additionalInformation: '',
        user:'',
        projects: [],

      },
    }
  },
  computed: {
    readonly() {
      return !this.$store.getters.checkPermission('can_manage_users') && this.$store.state.user.currentUser.id != this.projectCase.user_id
    },
    userProject() {
      return this.projectCase.projects.find(
        project =>
          project.responsible_user_id === this.$store.state.user.currentUser.id
      );
    },
    projectsCount() {
      return this.projectCase.projects.length || 0;
    }

  },
  methods: {
    async load() {
      const item = (await cases.item({ id: this.$route.params.case_id })).data
      this.projectCase = {
        ...item,
        companyName: item.company_name,
        companyDescription: item.company_description,
        companyRepresentativeName: item.company_representative_name,
        companyRepresentativePosition: item.company_representative_position,
        currentState: item.current_state,
        additionalInformation: item.additional_information,
        projects: item.projects,
        projectTypeId: item.project_type_id
      }
    },
    async update() {
      this.loading = true
      try {
        await cases.update(this.projectCase)
        this.errors = []
      }
      catch (e) {
        this.errors = e.response.data.errors
      }
      await this.load()
      this.loading = false
    },
    async createProject() {
      if (!this.userProject && !this.$store.getters.checkPermission('can_create_project')) return
      this.loading = true
      this.createError = ''
      try {
        const project = (await cases.buildProject(this.projectCase.id)).data
        this.$router.push(`/projects/${project.id}`)
      } catch (e) {
        this.createError = validationMessage(e)
      } finally {
        this.loading = false
      }
    },
    async deleteCase() {
      this.loading = true
      await cases.delete({ id: this.projectCase.id })
      this.$router.push('/cases')
      this.loading = false
    },
  },
  async mounted() {
    if (!this.$store.state.user.currentUser.id) return this.$router.push('/auth')
    this.$store.dispatch('getProjectTypes');
    this.isCaseProjectLoading = true
    await this.load()
    this.isCaseProjectLoading = false
  },
}
</script>

<template>
  <v-container>
    <div>
      <div style="background: white; padding: 20px; border-radius: 20px; "
        class="text-center text-md-left mb-4 d-flex flex-md-row flex-column align-center justify-center justify-md-start">
        <div style="max-width: 100%; width: 100%;">
          <div class="d-flex align-center justify-space-between flex-wrap">

            <h2 class="max-2-lines">
              {{ projectCase.title }}
            </h2>
            <v-chip :loading="loading" outlined destructive class="align-self-start; mt-2">
              Проектов: {{ projectsCount }}/3
            </v-chip>
          </div>
          <div class="d-flex flex-md-row flex-column align-center mb-4">
            <UserLinkComponent class="mr-0 mr-md-2 mt-2" :user="projectCase.user" />

            <v-chip rounded small class="mt-2" color="info" dark>
              {{ projectCase.companyName }}
            </v-chip>

          </div>
          <div class="d-flex flex-md-row flex-column  align-mb-center mb-4" style="gap: 4px">



            <v-btn v-if="userProject" @click="createProject" :loading="loading" outlined color="blue">
              Текущий проект
            </v-btn>


            <v-btn v-else-if="projectsCount < 3 && $store.getters.checkPermission('can_create_project')" @click="createProject" :loading="loading" outlined color="blue">
              Новый проект
            </v-btn>

            <v-btn v-if="projectsCount != 0" :loading="loading" outlined color="blue" :to="{
              name: 'projects',
              query: {
                case_ids: projectCase.id.toString()
              }
            }">
              Проекты кейса
            </v-btn>


            <v-btn v-if="!readonly" @click="deleteCase" :loading="loading" outlined destructive color="red">Удалить
              кейс</v-btn>
          </div>
          <v-alert v-if="createError" type="error" text dense>
            {{ createError }}
          </v-alert>
        </div>
      </div>

      <v-sheet class="pa-4">
        <v-text-field :loading="isCaseProjectLoading" :readonly="readonly"
          placeholder="Безбарьерная среда для маломобильных групп населения" label="Название кейса" rounded
          style="border-radius: 10px; border-color: #efefef;" v-model="projectCase.title" outlined
          :error-messages="errors.title" />

        <v-autocomplete :loading="isCaseProjectLoading" :readonly="readonly" placeholder="Технический проект"
          label="Тип проекта" rounded style="border-radius: 10px; border-color: #efefef;"
          v-model="projectCase.projectTypeId" :items="$store.state.projects.project_types" auto-select-first
          autocomplete="off" item-text="name" item-value="id" outlined :error-messages="errors.projectTypeId" />

        <v-text-field :loading="isCaseProjectLoading" :readonly="readonly"
          label="Полное название компании, предоставившей кейс" placeholder="ООО «Югорский Экспертный Центр»" rounded
          style="border-radius: 10px; border-color: #efefef;" v-model="projectCase.companyName" outlined
          :error-messages="errors.companyName" />

        <v-text-field :loading="isCaseProjectLoading" :readonly="readonly" label="ФИО эксперта"
          placeholder="Юлия Евгеньевна Ерохина" rounded style="border-radius: 10px; border-color: #efefef;"
          v-model="projectCase.companyRepresentativeName" outlined :error-messages="errors.companyRepresentativeName" />

        <v-text-field :loading="isCaseProjectLoading" :readonly="readonly" label="Должность эксперта"
          placeholder="Генеральный директор" rounded style="border-radius: 10px; border-color: #efefef;"
          v-model="projectCase.companyRepresentativePosition" outlined
          :error-messages="errors.companyRepresentativePosition" />

        <v-divider />
        <v-textarea :readonly="readonly" v-model="projectCase.companyDescription" outlined
          hint="чем занимается, ассортимент продукции/услуг, оборот, на каких рынках работает, используемые технологии, информация о составе рабочего коллектива"
          label="Описание деятельности компании " :error-messages="errors.companyDescription" />

        <v-textarea :readonly="readonly" v-model="projectCase.problem" outlined label="Описание проблемной ситуации"
          :error-messages="errors.problem" />

        <v-textarea :readonly="readonly" v-model="projectCase.currentState" outlined label="Как пытались решить?"
          :error-messages="errors.currentState" />

        <v-textarea :readonly="readonly" v-model="projectCase.product" outlined
          label="Желаемый образ результата (продукта)" :error-messages="errors.product" />

        <v-textarea :readonly="readonly" v-model="projectCase.additionalInformation" outlined
          label="Дополнительные материалы" :error-messages="errors.additionalInformation" />

        <v-btn v-if="!readonly" @click="update" :loading="loading" outlined color="blue">Сохранить</v-btn>
      </v-sheet>
    </div>
  </v-container>
</template>

<style scoped></style>
